import CONFIGS from 'build/Config'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { useSession } from 'contexts/session-context'
import { useLocalStorage } from 'react-use'
import utmServices from 'services/utm-services'
import useRouter from 'hooks/use-router'
import { Redirect, useRouteMatch } from 'react-router-dom'
import AlbumPopup from './album-popup'
import PopUpError from './popup-error'

const AlbumQr = () => {
  const [{ user }] = useSession()
  const route = useRouteMatch<{ rallyType: string; url: string }>()
  const { history } = useRouter()
  const [popUp, setPopUp] = useLocalStorage('albumQrPopUp', false)

  const error = null

  const utm = utmServices.utmRead() || {}
  const utmString = Object.entries(utm)
    ?.map(([key, value]) => `${key}=${value}`)
    ?.join('&')

  const handleClick = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Album - Comencemos', value: '10' })
    dlTrackEvent('user_interaction', { action: 'click', element: 'comencemos', section: 'Album' })

    if (!user) {

      const redirectUrl = utmString
        ? `/album/redirect/${route.params.rallyType}/${route.params.url}?qr=true&${utmString}`
        : `/album/redirect/${route.params.rallyType}/${route.params.url}?qr=true`

      localStorage.setItem('internal_redirect', redirectUrl)

      return history.push('/start')
    }

    if (!popUp && CONFIGS?.albumQrPopUp) {
      setPopUp(true)
    }
  }

  if (error) {
    return <PopUpError errorCode={9999} />
  }

  if (!user || (!popUp && CONFIGS?.albumQrPopUp)) {
    return <AlbumPopup handleClick={handleClick} rallyType={route.params.rallyType} />
  }

  const redirectUrl = utmString
    ? `/album/redirect/${route.params.rallyType}/${route.params.url}?qr=true&${utmString}`
    : `/album/redirect/${route.params.rallyType}/${route.params.url}?qr=true`

  return <Redirect to={redirectUrl} />
}

export default AlbumQr
